import axios from 'axios';

export function getStudentStripeDefaultPaymentMethod(id) {
  return axios.get(`/api/students/${id}/stripe-default-payment-method`);
}

export function getStudentPaymentMethods(id, type) {
  return axios.get(`/api/students/${id}/payment-methods?type=${type}`);
}

export function getStudentSetupIntent(id) {
  return axios.get(`/api/students/${id}/intent`);
}
